import { AlertUtil } from './../utils/alert-util';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { IDocumento } from '../interfaces/IDocumento';
import { IVersione } from '../interfaces/IVersione';
import { RequestBuilder } from '../classes/request-builder';
import { DocumentiService } from '../services/documenti.service';
import { Loading } from '../utils/loading';
import { finalize } from 'rxjs/operators';
import { Util } from '../utils/util';

@Component({
  selector: 'app-choise-doc-version-modal',
  templateUrl: './choise-doc-version-modal.component.html',
  styleUrls: ['./choise-doc-version-modal.component.css']
})
export class ChoiseDocVersionModalComponent implements OnInit {
  document: IDocumento
  versionList: IVersione[] = []              //versionList of document 
  maxVersion: number                         //index max of version
  selectedVersion: IVersione;
  isPrefetto: boolean // check user role

  constructor(private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private documentiService:DocumentiService,
    private alertUtil:AlertUtil) {
    this.document = this.config.data.documento
    this.isPrefetto = this.config.data.isPrefetto
    if (this.document.Versioni) {
      this.document.Versioni.forEach(doc => {
        //push in array only confirmed doc
        if (doc.Confermato) {
          this.versionList.push(doc)
        }
      })
      this.maxVersion = this.getMaxOfArray()
      this.selectedVersion = this.versionList.find(version => version.Versione == this.maxVersion)
    }
  }

  ngOnInit() {
  }

  /**
   * return max value of number array
   * @param numArray 
   */
  getMaxOfArray(): number {
    let versionNumber: number[] = [];
    this.versionList.forEach(version => {
      versionNumber.push(version.Versione);
    });
    return Math.max.apply(null, versionNumber);
  }

  /**
   * on change dropdown versioni
   * @param event 
   */
  download() {
    if(this.isPrefetto){ //if prefetto close modal with selectedVersion
        this.ref.close(this.selectedVersion)
    }else{
      this.callVisualizzaPdf()
    }
  }

  /**
   * call visualizza Pdf service
   * @param documento 
   */
  private callVisualizzaPdf() {
    Loading.isLoading = true;
    let documentoCloned: IDocumento = {
      Id: this.document.Id,
      Nome: this.document.Nome,
      Descrizione: this.document.Descrizione,
      Tipologia: this.document.Tipologia,
      Data_scadenza: this.document.Data_scadenza,
      Documento: this.document.Documento,
      DocumentoCreato: this.document.DocumentoCreato,
      Autore: this.document.Autore,
      Versione: this.selectedVersion.Versione
    };
    let reqBuilder = new RequestBuilder(documentoCloned);
    this.documentiService.showPDF(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false;
    })).subscribe(response => {
      if (response && response["error"] == null) {
        Util.showPdf(response);
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code;
        this.alertUtil.showErrorAlert(errorKey);
        console.log("ERROR: " + JSON.stringify(response.error.Stack));
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message });
      }
    }, error => {
      let errorKey = "LBL_HTTP_ERROR_0";
      if (error.status) {
        errorKey = "LBL_HTTP_ERROR_" + error.status;
      }
      this.alertUtil.showErrorAlert(errorKey);
    });
  }

}
